/**
 * Confirms a tenant switch, naming the organization being left and the one being entered.
 */
import { useTranslation } from 'react-i18next';
import { ConfirmActionModal } from '@insio/ui-toolkit';

interface SwitchAccountConfirmModalProps {
  /** Organization the session is leaving. */
  fromName: string;
  /** Organization the session would enter. */
  toName: string;
  loading?: boolean;
  onConfirm: () => void;
  onClose: () => void;
}

export function SwitchAccountConfirmModal({
  fromName,
  toName,
  loading = false,
  onConfirm,
  onClose
}: SwitchAccountConfirmModalProps) {
  const { t } = useTranslation();

  return (
    <ConfirmActionModal
      title={t('features.auth.switchAccount.title')}
      message={t('features.auth.switchAccount.message', { from: fromName, to: toName })}
      warning={t('features.auth.switchAccount.warning', { to: toName })}
      confirmLabel={t('features.auth.switchAccount.confirm', { to: toName })}
      variant='primary'
      loading={loading}
      onConfirm={onConfirm}
      onClose={onClose}
      testId='switch-account-confirm'
    />
  );
}
